module.exports = __webpack_public_path__ + "media/1alB-n-gu'n.f09edcd4.mp3";